import { closeCurrentDropdown, initializeDropdowns, toggleAriaExpanded } from './utils';
import noUiSlider from 'nouislider';

const container = document.querySelector('.archive-container');

let archiveFilter;
let distanceFilter;
let distanceSlider;
let paginationLinks;
let filtering = false;

function initializeFilter() {
    archiveFilter = document.querySelector('.archive-filters');
    distanceFilter = document.querySelector('.archive-filters-distance');
    resetButton = document.querySelector('.archive-filters-reset');
    paginationLinks = container.querySelectorAll('.pagination a');

    archiveFilter.addEventListener('submit', e => {
        e.preventDefault();
        closeCurrentDropdown();
        executeFilter();
    });

    archiveFilter.addEventListener('change', e => {
        // When a subchoice is checked, uncheck the parent checkbox
        if (e.target.type === 'checkbox' && e.target.checked && e.target.closest('.archive-filters-subchoices')) {
            const parentChoice = e.target.closest('.archive-filters-subchoices').previousElementSibling;
            const parentCheckbox = parentChoice.querySelector('input[type="checkbox"]');
            parentCheckbox.checked = false;å
        }
    });

    resetButton?.addEventListener('click', () => {
        resetFilter();
        executeFilter();
    });

    // resetButtons?.forEach(button => {
    //     button.addEventListener('click', () => {
    //         resetFilter(button.dataset.name, button.dataset.value);
    //         executeFilter();
    //     });
    // });

    if (distanceFilter) {
        const container = distanceFilter.querySelector('.archive-filters-distance-slider');
        const minInput = distanceFilter.querySelector('.archive-filters-distance-min');
        const maxInput = distanceFilter.querySelector('.archive-filters-distance-max');
        const minDefault = 0;
        const maxDefault = parseInt(maxInput.getAttribute('max'));
        const minValue = parseInt(minInput.value);
        const maxValue = parseInt(maxInput.value);

        distanceSlider = noUiSlider.create(container, {
            start: [minValue, maxValue],
            connect: true,
            range: {
                min: minDefault,
                max: maxDefault,
            },
            format: {
                to: value => parseInt(value),
                from: value => parseInt(value),
            },
            step: 1,
        });

        distanceSlider.on('update', function (values, handle) {
            if (handle === 0) {
                minInput.value = values[handle];
            } else if (handle === 1) {
                maxInput.value = values[handle];
            }
        });

        distanceSlider.reset = function () {
            distanceSlider.set([minDefault, maxDefault]);
        };
        
        minInput.addEventListener('input', function () {
            distanceSlider.set([this.value, null]);
        });

        maxInput.addEventListener('input', function () {
            distanceSlider.set([null, this.value]);
        });
    }

    paginationLinks.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            executeFilter(link.href, () => {
                window.scrollTo({
                    top: container.closest('section').offsetTop - 120,
                    behavior: 'smooth',
                });
            });
        });
    });
}

function executeFilter(url = null, callback = null) {
    if (filtering) return;
    filtering = true;

    if (!url) {
        url = archiveFilter.action + '?' + new URLSearchParams(new FormData(archiveFilter)).toString();
    }

    container.classList.add('loading');
    history.pushState({}, '', url);

    fetch(url)
        .then(response => response.text())
        .then(html => {
            const temp = document.createElement('div');
            temp.innerHTML = html;

            const newContainer = temp.querySelector('.archive-container');

            if (newContainer) {
                container.innerHTML = newContainer.innerHTML;
            }
            
            initializeFilter();
            initializeDropdowns(container);

            container.classList.remove('loading');
            callback && callback();
            filtering = false;
        });
}

function resetFilter(name = '', value = '') {
    const selector = name ? `[name="${name}"]` : 'input, select';
    console.log(selector);
    archiveFilter.querySelectorAll(selector).forEach(input => {
        console.log(input, name, value);
        if ((input.type === 'checkbox' || input.type === 'radio') && (!value || input.value === value)) {
            input.checked = false;
        }

        if (['text', 'date', 'search'].includes(input.type)) {
            input.value = '';
        }
    });

    if (!name || name === '_distance') {
        resetDistanceSlider();
    }
}

function resetDistanceSlider() {
    if (!distanceSlider) {
        return;
    }

    distanceSlider.reset(); // Does this work? No idea
}

initializeFilter();